import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  @Input() type: 'success' | 'warning' | 'danger' | 'info' | 'purple' | '' = '';
  @Input() message?: string;
  @Input() messageTemplate?: TemplateRef<any>;
  @Input() subtitle?: string;
  @Input() link?: string;
  @Input() icon?: string;
  @Input() paddingLeftIcon = 'ml-16';
  @Input() lineHeight = '';
  @Input() extrasClas?: string = '';
  @Output() clickLinkEvent = new EventEmitter();
  alertClass = 'row items-center rounded p-16 ';
  iconClass = '';

  constructor() {}

  ngOnInit(): void {
    switch (this.type) {
      case 'success':
        this.alertClass += 'u-alert-success';
        this.iconClass = 'success';
        this.icon = `${this.icon || 'done'}`;
        break;
      case 'info':
        this.alertClass += 'u-alert-info';
        this.iconClass = 'accent';
        this.icon = `${this.icon || 'info'}`;
        break;
      case 'warning':
        this.alertClass += 'u-alert-warning';
        this.iconClass = 'warning';
        this.icon = `${this.icon || 'warning_amber'}`;
        break;
      case 'danger':
        this.alertClass += 'u-alert-danger';
        this.iconClass = 'warn';
        this.icon = `${this.icon || 'warning_amber'}`;
        break;
      case 'purple':
        this.alertClass += `u-alert-purple ${this.extrasClas}`;
        this.iconClass = 'primary';
        this.icon = `${this.icon || 'warning_amber'}`;
        break;
      default:
        this.alertClass += 'u-alert-default';
        this.iconClass = '';
        this.icon = `${this.icon || 'warning_amber'}`;
        break;
    }
  }
}
